import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 47px;
  border: 2px solid #ffffff;
  border-radius: 190px;
  background: transparent;

  span {
    font-size: 1.125rem;
    font-weight: 400;
    color: #ffffff;
  }

  @media (max-width: 960px) {
    width: 30%;
  }
`;
